<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { SchoolMe } from '@/core/domain/school/core/School.ts'
import type SchoolClassroom from '@/core/domain/school/classroom/SchoolClassroom.ts'
import { computed } from 'vue'
import CBaseCard from '@/presentation/components/base/CBaseCard.vue'
import { useRouter } from 'vue-router'
import { useDashboardStore } from '@/presentation/stores/dashboard/dashboard.ts'
import { useDashboardClassroomStore } from '@/presentation/stores/dashboard/dashboardClassroom.ts'

// COMPOSABLES & SEVICES
const router = useRouter()

// PROPS
const props = defineProps<{
  school: SchoolMe
  classroom: SchoolClassroom | null
}>()

// STORE ACTIONS
const { setDashboardSelectedSchool } = useDashboardStore()
const { setDashboardSelectedClassroom } = useDashboardClassroomStore()

// ACTIONS
const showClassroom = () => {
  if (!props.school || !props.classroom) return

  // Set selected school and classroom
  setDashboardSelectedSchool(props.school)
  setDashboardSelectedClassroom(props.classroom)

  // Redirect to school page
  router.push({
    name: 'dashboard-group',
    params: {
      schoolId: props.school.id,
      classroomId: props.classroom.schoolClassroomId
    }
  })
}

// COMPUTED
const count = computed(() => {
  return {
    students: props.classroom?.students?.length || 0,
    teachers: props.classroom?.teachers?.length || 0
  }
})
</script>

<template>
  <div class="col-span-6 lg:col-span-3">
    <c-base-card
      v-if="school && classroom"
      class="border-bo-brand-secondary flex h-full flex-col overflow-hidden rounded-xl border p-6"
      :title="classroom.name"
      has-footer
    >
      <template #content>
        <p class="w-full">
          <i class="pi pi-home" />
          {{ `${school.name} (${school.city})` }}
        </p>

        <p class="w-full">
          <i class="pi pi-users" />
          {{ count.students }} élève(s)
        </p>

        <p class="w-full">
          <FontAwesomeIcon icon="chalkboard-teacher" />
          {{ count.teachers }} enseignant(s) référent(s)
        </p>
      </template>

      <template #footer>
        <a class="bo-active-color cursor-pointer text-right no-underline" @click="showClassroom">
          Afficher la classe
        </a>
      </template>
    </c-base-card>
    <c-base-card v-else title="Aucune classe" without-content />
  </div>
</template>
